import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { GridActionsCellItem } from '@mui/x-data-grid';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { useDispatch, useSelector} from 'react-redux';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { delete_payment, get_byDate } from 'http/components/AppointmentService';
import { SetAppointmentsData } from 'Utils/Helpers/HandleApiData';
import { TextShow } from 'Utils/Helpers/TextShow';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DeletePayment({ cell, row }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [semi, setSemi] = useState(false);
  const { dateSearch } = useSelector((state) => ({
    dateSearch: state.setting.dateSearch,
  }));
  const setShowDialog = () => {
    setShow(true);
  }
  const handleClose= () => {
    setShow(false);
  }
  const onEnter = () => {
    setSemi(false);
  }
  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const response = await delete_payment(row.id);
    if(response.status) {
      const response2 = await get_byDate(dateSearch.date);
      if(response2.status) {
          await dispatch(SetAppointmentsData(response2.data))
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      dispatch(HandleLoading(false));
    }
    setShow(false);
  }
  return (
    <>
      <GridActionsCellItem
          icon={<icons.Trash3 size={16}/>}
          label="Delete"
          onClick={setShowDialog}
          disabled={row.patient}
          hidden={row.patient}
      />
      {
        show &&
        <Dialog
          open={show}
          TransitionComponent={Transition}
          keepMounted
          fullWidth={true}
          maxWidth={'xs'}
          onClose={handleClose}
          TransitionProps={{onEnter: onEnter}}
          aria-describedby="alert-dialog-slide-appointment-edit"
        >
          <DialogTitle className='delete-mode'>
            {`حذف پرداخت`}
            <div className='close-btn' onClick={handleClose}>
              <icons.X/>
            </div>
          </DialogTitle>
          <DialogContent>
            {
              (show && !semi) ?
              <DialogContentText id="alert-dialog-slide-appointment-edit">
                <div className='delete-body'>
                  <div className='content'>
                    <p>
                      {'از حذف پرداخت با مشخصات زیر اطمینان دارید ؟'}
                    </p>
                    <div className='details'>
                      <TextShow
                          title={"تاریخ پرداخت :"}
                          data={row.date}
                          className={'no-hide text-muted'}
                      />
                      <TextShow
                          title={"مبلغ پرداخت :"}
                          data={row.price}
                          className={'no-hide text-muted'}
                      />
                      <TextShow
                          title={"کاربر ثبت کننده :"}
                          data={row.creatingUser}
                          className={'no-hide text-muted'}
                      />
                      <TextShow
                          title={"توضیحات :"}
                          data={row.description}
                          className={'no-hide text-muted'}
                      />
                    </div>
                  </div>
                </div>
              </DialogContentText> : <p className='mb-1'>
                {"آیا از حذف مطمئن هستید ؟"}
              </p>
            }
          </DialogContent>
          <DialogActions>
            {
              semi
              ? <div className='w-100 flex-row-center-center'>
                <CButton
                  text={'خیر'}
                  icon={<icons.XLg/>}
                  onClick={handleClose}
                  action=''
                  className={'ms-2'}
                />
                <CButton
                  text={'بله'}
                  icon={<icons.Trash3/>}
                  onClick={onFinish}
                  action='delete'
                />
              </div>
              : <CButton
                text={'حذف پرداخت'}
                icon={<icons.Trash3/>}
                onClick={() => setSemi(true)}
                action='delete'
              />
            }
          </DialogActions>
        </Dialog>
      }
    </>
  );
}
